import { createSlice } from "@reduxjs/toolkit";

const DashbaordInfoSlice = createSlice({
  name: "dashboardInfo",
  initialState: {
    loading: false,
    data: null,
    message: "",
    error: null,
  },
  reducers: {
    fetchDashboardInfoRequest: (state) => {
      state.loading = true;
        state.error = null;
        state.data = null;
    },
    fetchDashboardInfoSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.dashboardInfo;
      state.message = action.payload.message;
      state.error = null;
    },
    fetchDashboardInfoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
        state.data = null;
    },

    clearDashboardInfo: (state) => {   
      state.data = null;
      state.error = null;
      state.loading = false;
    },

    // Create Info
    createDashboardInfoRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createDashboardInfoSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.error = null;

    },
    createDashboardInfoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    
  },
});

export const {
  fetchDashboardInfoRequest,
  fetchDashboardInfoSuccess,
  fetchDashboardInfoFailure,
  createDashboardInfoRequest,
  createDashboardInfoSuccess,
  createDashboardInfoFailure,
  clearDashboardInfo,
} = DashbaordInfoSlice.actions;

export default DashbaordInfoSlice.reducer;
